import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { Checkbox } from '@mui/material';

import asyncService from '../../../datahub/asyncService';
import selectUser from '../../store/selectors/appSelector';

import ItemList from './ItemList';

const LocationEntry = ({ city, state, address, description, isChecked, onChange }) => (
  <>
    <Checkbox
      size="small"
      //   disabled={!isAllSelected}
      checked={!!isChecked}
      // onClick={(e) => e.stopPropagation()}
      onChange={onChange}
    />
    {city}, {state} {address} {description}
  </>
);

LocationEntry.propTypes = {
  city: PropTypes.string,
  state: PropTypes.string,
  address: PropTypes.string,
  description: PropTypes.string,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func,
};

const LocationSelectionList = ({ corpId, isReadyToLoad, locationData, setLocationData }) => {
  const { token, refreshToken } = useSelector(selectUser);

  const dispatch = useDispatch();

  const buildLocationItemToDisplay = (location) => (
    <LocationEntry
      key={location?._id}
      city={location?.city}
      state={location?.state}
      address={location?.address}
      description={location?.description}
      isChecked={location?.isSelected}
      onChange={() =>
        setLocationData(
          locationData.map(
            (x) =>
              (x?._id === location?._id && { ...location, isSelected: !location?.isSelected }) || x
          )
        )
      }
    />
  );

  const corporationFilter = {
    field: 'corporation._id',
    operation: 'equalsID',
    value: corpId,
  };

  const locationListSearchData = {
    filters: [corporationFilter], // candidate filter + any custom filters
    limit: 10,
  };

  const locationsRequest = (setNeededDocumentCount, setIsLoading, page, currentLocationData) =>
    asyncService({
      httpMethod: 'POST',
      route: 'locations/read',
      data: { ...locationListSearchData, page },
      onSuccess: (results) => {
        const locationDocuments = results?.data?.documents || [];
        const totalDocCount = results?.data?.count || 0;
        setNeededDocumentCount(totalDocCount);
        setLocationData([...currentLocationData, ...locationDocuments]);
        setIsLoading(false);
      },
      onError: () => {
        // handle error
        setIsLoading(false);
      },
      dispatch,
      token,
      refreshToken,
    });

  return (
    <ItemList
      buildItemToDisplay={buildLocationItemToDisplay}
      isReadyToLoad={isReadyToLoad}
      requestApi={locationsRequest}
      items={locationData}
    />
  );
};

LocationSelectionList.propTypes = {
  corpId: PropTypes.string,
  isReadyToLoad: PropTypes.bool,
  locationData: PropTypes.arrayOf(PropTypes.shape({})),
  setLocationData: PropTypes.func,
};

export default LocationSelectionList;
